<template>
  <div class="body">
    <el-card class="box-card mb20">
      <el-form ref="form" :model="listParams" label-width="80px" @submit.native.prevent class="operationControl">
        <el-row>
          <el-col :span="5" class="pr20">
            <el-form-item label="培训课程" prop="trainingName">
              <el-input v-model="listParams.trainingName" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="关联计划" prop="safetyTrainingProgramId">
              <el-select clearable v-model="listParams.safetyTrainingProgramId" placeholder="选择关联计划">
                <el-option
                  v-for="(item, index) in safetyTrainingProgramOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" class="pr20" style="margin-left: 30px">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button type="primary" @click=" $refs.selectCourse.show();">新增任务</el-button>
          </el-col>
        </el-row>
      </el-form>
      <selectCourse ref="selectCourse"/>
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        :data="recordList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="selectionChange" height="640">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="任务名称" prop="taskName">
          <template slot-scope="scope">
            <span v-if="scope.row.taskName" v-html="scope.row.taskName"></span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="课程名称" prop="trainingName"></el-table-column>
        <el-table-column
          label="开始时间"
          prop="trainingStartTime"
        ></el-table-column>
        <el-table-column
          label="结束时间"
          prop="trainingEndTime"
        ></el-table-column>
        <el-table-column
          label="计划人数"
          prop="programNumber"
        ></el-table-column>
        <el-table-column label="实到人数" prop="actualNumber"></el-table-column>
        <el-table-column label="完成率">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.completionRate * 100).toFixed(2) || 0 }}%</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="lookDetail(scope.row.programId, scope.row.id, scope.row.taskName)" type="text"
            >详情
            </el-button>
            <el-button
              @click="showSelectFile(scope.row.id)"
              type="text"
            >档案
            </el-button>
            <el-button
              @click="showExamInformation(scope.row.id)"
              type="text"
            >关联考试
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:20px; float:right;"
        @size-change="sizeChange"
        :current-page="listParams.page"
        @current-change="pageChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="listParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <taskFile ref="taskFile"></taskFile>
    </el-card>

    <!-- 详情 -->
<!--    <el-dialog title="详情" :visible.sync="detailVisible" width="70%">-->
<!--      &lt;!&ndash;      <h2 class="body-title">计划详情</h2>&ndash;&gt;-->
<!--      &lt;!&ndash;      <div class="trainDetail">&ndash;&gt;-->
<!--      &lt;!&ndash;        <el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">培训名称：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.trainingName }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">下达时间：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.issuedTimeString }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-row>&ndash;&gt;-->

<!--      &lt;!&ndash;        <el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">制定日期：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.createdTimeString }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">预计实时日期：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.implementationTimeString }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-row>&ndash;&gt;-->

<!--      &lt;!&ndash;        <el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">责任人：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.principalName }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">组织单位：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.department }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-row>&ndash;&gt;-->

<!--      &lt;!&ndash;        <el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">地点：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span>{{ detail.location }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="12" style="border-bottom:1px solid #99999950;">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">附件列表：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <span v-for="item in detail.annexList" :key="item">{{ item }}</span>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-row>&ndash;&gt;-->

<!--      &lt;!&ndash;        <el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;          <el-col :span="24">&ndash;&gt;-->
<!--      &lt;!&ndash;            <span class="span-left">培训内容：</span>&ndash;&gt;-->
<!--      &lt;!&ndash;            <div style="margin-left: 300px" v-html="detail.trainingContent"></div>&ndash;&gt;-->
<!--      &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->
<!--      &lt;!&ndash;      <h2 class="body-title">任务详情</h2>&ndash;&gt;-->

<!--      <div-->
<!--        class="mission mb30"-->
<!--        v-for="(item, index) in detail.tasksList"-->
<!--        :key="index">-->
<!--        &lt;!&ndash;        <div class="title">培训任务</div>&ndash;&gt;-->
<!--        &lt;!&ndash;        <el-row style="margin-bottom:16px">&ndash;&gt;-->
<!--        &lt;!&ndash;          <el-col&ndash;&gt;-->
<!--        &lt;!&ndash;            :span="10"&ndash;&gt;-->
<!--        &lt;!&ndash;            style="display:flex;align-items: center;padding:0 10px;">&ndash;&gt;-->
<!--        &lt;!&ndash;            <span class="span-left">培训讲师</span>&ndash;&gt;-->
<!--        &lt;!&ndash;            <el-input size="mini" v-model="item.trainer" disabled></el-input>&ndash;&gt;-->
<!--        &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--        &lt;!&ndash;          <el-col&ndash;&gt;-->
<!--        &lt;!&ndash;            :span="10"&ndash;&gt;-->
<!--        &lt;!&ndash;            style="display:flex;align-items: center;padding:0 10px;">&ndash;&gt;-->
<!--        &lt;!&ndash;            <span class="span-left">讲师资质</span>&ndash;&gt;-->
<!--        &lt;!&ndash;            <el-input&ndash;&gt;-->
<!--        &lt;!&ndash;              size="mini"&ndash;&gt;-->
<!--        &lt;!&ndash;              v-model="item.trainerCondition"&ndash;&gt;-->
<!--        &lt;!&ndash;              disabled&ndash;&gt;-->
<!--        &lt;!&ndash;            ></el-input>&ndash;&gt;-->
<!--        &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--        &lt;!&ndash;        </el-row>&ndash;&gt;-->
<!--        &lt;!&ndash;        <el-row class="mb20">&ndash;&gt;-->
<!--        &lt;!&ndash;          <el-col&ndash;&gt;-->
<!--        &lt;!&ndash;            :span="12"&ndash;&gt;-->
<!--        &lt;!&ndash;            style="display:flex;align-items: center;padding:0 10px;"&ndash;&gt;-->
<!--        &lt;!&ndash;          >&ndash;&gt;-->
<!--        &lt;!&ndash;            <span class="span-left" style="width: 140px">培训开始时间</span>&ndash;&gt;-->
<!--        &lt;!&ndash;            <el-input&ndash;&gt;-->
<!--        &lt;!&ndash;              size="mini"&ndash;&gt;-->
<!--        &lt;!&ndash;              v-model="item.trainingStartTimeString"&ndash;&gt;-->
<!--        &lt;!&ndash;              disabled&ndash;&gt;-->
<!--        &lt;!&ndash;            ></el-input>&ndash;&gt;-->
<!--        &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--        &lt;!&ndash;          <el-col&ndash;&gt;-->
<!--        &lt;!&ndash;            :span="12"&ndash;&gt;-->
<!--        &lt;!&ndash;            style="display:flex;align-items: center;padding:0 10px;"&ndash;&gt;-->
<!--        &lt;!&ndash;          >&ndash;&gt;-->
<!--        &lt;!&ndash;            <span class="span-left" style="width: 140px">要求完成时间</span>&ndash;&gt;-->
<!--        &lt;!&ndash;            <el-input&ndash;&gt;-->
<!--        &lt;!&ndash;              size="mini"&ndash;&gt;-->
<!--        &lt;!&ndash;              v-model="item.trainingEndTimeString"&ndash;&gt;-->
<!--        &lt;!&ndash;              disabled&ndash;&gt;-->
<!--        &lt;!&ndash;            ></el-input>&ndash;&gt;-->
<!--        &lt;!&ndash;          </el-col>&ndash;&gt;-->
<!--        &lt;!&ndash;        </el-row>&ndash;&gt;-->

<!--        <el-table :data="item.tasksJoinUsers" v-loading="!item.tasksJoinUsers" element-loading-text="拼命加载中" class="mb20"-->
<!--                  style="width: 100%;">-->
<!--          <el-table-column-->
<!--            type="index"-->
<!--            label="序号"-->
<!--            width="80"-->
<!--          ></el-table-column>-->
<!--          <el-table-column prop="userName" label="培训对象"></el-table-column>-->
<!--          <el-table-column prop="userPhone" label="电话"></el-table-column>-->
<!--          <el-table-column prop="totalHours" label="课程总时长"></el-table-column>-->
<!--          <el-table-column prop="totalHoursLearned" label="已学习时长（分）">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.totalHoursLearned" v-html="scope.row.totalHoursLearned">-->
<!--              </span>-->
<!--              <span v-else>-->
<!--                0-->
<!--              </span>-->
<!--            </template>-->

<!--          </el-table-column>-->
<!--          <el-table-column label="状态">-->
<!--            <template slot-scope="scope">-->
  <!--              <span v-if="scope.row.totalHoursLearned >= scope.row.totalHours">-->
<!--                已完成-->
<!--              </span>-->
<!--              <span v-else>-->
<!--                 学习中-->
<!--              </span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column label="操作" width="350">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button-->
<!--                type="text"-->
<!--                size="mini"-->
<!--                @click="showStudyProgress(scope.row.id)"-->
<!--              >查看详情-->
<!--              </el-button>-->
<!--              <el-button-->
<!--                type="text"-->
<!--                size="mini"-->
<!--                @click="pushTraininReminderMessage(scope.row.id)"-->
<!--              >培训提醒消息-->
<!--              </el-button>-->
<!--              <el-button-->
<!--                v-if="scope.row.totalHoursLearned >= scope.row.totalHours"-->
<!--                size="mini"-->
<!--                type="text"-->
<!--                @click="trainingRecordExport(scope.row)">导出培训记录-->
<!--              </el-button>-->
<!--              <el-button-->
<!--                v-if="scope.row.totalHoursLearned >= scope.row.totalHours"-->
<!--                size="mini"-->
<!--                type="text"-->
<!--                @click="proofOfClassHoursExport(scope.row)">生成学时证明-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->

<!--      </div>-->
<!--      <studyProgress ref="studyProgress" :id="detailId"></studyProgress>-->
<!--      <span slot="footer">-->
<!--        <div class="f-b-c">-->
<!--          <div></div>-->
<!--          <div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </span>-->
<!--    </el-dialog>-->
      <taskDetails ref="taskDetails"></taskDetails>
  </div>
</template>

<script>
import API from "../../../api/new/training.js";
import student from "@/api/new/student.js";
import studyProgress from "@/components/studyProgress";
import safetyRainingProgramApi from "@/api/new/safety_raining_program.js";
import employeeFile from "@/api/new/employee_file.js";
import trainingProgramTasksApi from "@/api/training/training_program_tasks.js";
import {bus} from "../../../bus";
import taskFile from "./taskFile";
import selectCourse from "@/pages/trainingManagement/task/selectCourse";
import taskDetails from "@/pages/trainingManagement/task/taskDetails";


export default {
  components: {studyProgress, selectCourse, taskFile, taskDetails},
  data() {
    return {
      recordList: [], // 题型列表
      detailVisible: false,
      total: 0,
      loading: true,
      detailId: undefined,
      id: "",
      detail: {},
      listParams: {
        page: 1,
        pageSize: 10,
        trainingName: undefined,
        trainingProgramId: "",
        teachingMethods: "",
        safetyTrainingProgramId: undefined
      },
      teaching_methods: [],
      safetyTrainingProgramOptions: [],
    };
  },
  mounted() {
    this.loadSafetyTrainingProgramOptions();
    this.search();
    this.teaching_methods = JSON.parse(
      localStorage.getItem("teaching_methods")
    );
  },
  methods: {
    showStudyProgress(id) {
      // this.$refs.studyProgress.dialogVisible = true;
      this.$refs.studyProgress.open(id);
    },
    pushTraininReminderMessage(id) {
      student.pushTraininReminderMessage({detailId: id}).then(res => {
        this.$message({
          message: '推送成功',
          type: 'success'
        });
      });
    },
    lookDetail(programId, id, taskName) {
      // 加载课程信息
      API.getTrainingProgram({
        programId: programId,
        recordId: id
      }).then(res => {
        this.detailVisible = true;
        this.detail = res.data;
        if (!res.data.tasksList) return;
        //任务批次加载
        res.data.tasksList.forEach((v, i) => {
          this.$refs.taskDetails.show(v.id, taskName, v.enableVerification == 1);
        });
      });
    },
    showSelectFile(recordId){
      trainingProgramTasksApi.details({
        recordId: recordId
      }).then(res => {
        let trainingProgramTasks = res.data;
        this.$refs.taskFile.showSelect(trainingProgramTasks.id);
      });
    },
    search(){
      this.listParams.page = 1;
      this.rainingRecordPageList();
    },
    //培训列表
    rainingRecordPageList() {
      let that = this;
      let listParams = {
        ...this.listParams,
        trainningRecordType: 1,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      !listParams.trainingName && delete listParams.trainingName;
      !listParams.trainingProgramId && delete listParams.trainingProgramId;
      !listParams.teachingMethods && delete listParams.teachingMethods;

      that.loading = true;
      API.rainingRecordPageList(listParams)
        .then(
          res => {
            that.loading = false;
            if (res && res.data.records) {
              that.recordList = res.data.records;
              console.log(  that.recordList)
              that.total = res.data.total;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    sizeChange(e){
      this.listParams.pageSize = e;
      this.rainingRecordPageList();
    },
    pageChange(e) {
      this.listParams.page = e;
      this.rainingRecordPageList();
    },
    /**
     * 重置表单
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.search();
    },
    /**
     * 表格多选回调
     */
    selectionChange(e) {
      console.log(e);
    },

    /**
     * 加载培训计划下拉框
     */
    loadSafetyTrainingProgramOptions() {
      let params = {
        method: 1
      }
      safetyRainingProgramApi.options(params).then(res => {
        if (res.code == 0) {
          this.safetyTrainingProgramOptions = res.data;
          console.log('loadSafetyTrainingProgramOptions: %o', this.safetyTrainingProgramOptions)
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     *  导出培训记录
     * */
    trainingRecordExport(row) {
      let parmas = {
        userId: row.userId,
        programTasksId: row.programTasksId
      }
      employeeFile.trainingRecordExport(parmas).then(res => {
        //  导出并下载文件
        window.location.href = res.data;
        this.$message.success("导出成功");
      }).catch( (error) => {
        console.log('error msg %o', error)
        this.$message.error({
          showClose: true,
          message: error.message,
          duration: 2000
        });
      });
    },
    /**
     * 生成学时证明
     */
    proofOfClassHoursExport(row) {
      let parmas = {
        userId: row.userId,
        trainingDetailListId: row.id
      }
      employeeFile.proofOfClassHoursExport(parmas).then(res => {
        //  导出并下载文件
        window.location.href = res.data;
        this.$message.success("导出成功");
      }) .catch( (error) => {
        console.log('error msg %o', error.response)
        this.$message.error({
          showClose: true,
          message: error.response.data.message,
          duration: 2000
        });
      });
    },
    showExamInformation(recordId) {
      trainingProgramTasksApi.details({
        recordId: recordId
      }).then(res => {
        let trainingProgramTasks = res.data;
        if (!trainingProgramTasks.trainingExamDetailListId) {
          this.$message.error({
            showClose: true,
            message: "当前下发任务未绑定考试信息",
            duration: 2000
          });
          return;
        }
        this.$router.push(`/trainingManagement/examInfo?id=` + trainingProgramTasks.id);
      });
    },
  }
};
</script>

<style scoped lang="less">
.trainDetail {
  padding: 30px;
  padding-top: 0;
}

.trainDetail span {
  font-size: 16px;
  line-height: 50px;
  display: inline-block;
}

.trainDetail .span-left {
  padding-left: 30px;
  width: 300px;
  text-align: right;
  white-space: nowrap;
}

.mission {
  .title {
    position: absolute;
    top: -10px;
    left: 16px;
    background: white;
  }

  position: relative;
  border: 1px solid #99999950;
  border-radius: 8px;
  padding: 20px 30px;

  .span-left {
    flex-shrink: 0;
    width: 110px;
    text-align: right;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/task/trainingTask.vue